import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { listarProdutos } from '../services/api';
import { categorias } from '../data/mockData';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const Produtos = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [categoriaAtiva, setCategoriaAtiva] = useState('todos');
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const categoria = searchParams.get('categoria');
    if (categoria) {
      setCategoriaAtiva(categoria);
    }
  }, [searchParams]);

  useEffect(() => {
    carregarProdutos();
  }, [categoriaAtiva]);

  const carregarProdutos = async () => {
    try {
      const categoria = categoriaAtiva === 'todos' ? null : categoriaAtiva;
      const data = await listarProdutos(categoria);
      setProdutos(data);
    } catch (error) {
      console.error('Erro ao carregar produtos:', error);
      setProdutos([]);
    } finally {
      setLoading(false);
    }
  };

  const handleCategoriaClick = (categoriaId) => {
    setCategoriaAtiva(categoriaId);
    if (categoriaId === 'todos') {
      setSearchParams({});
    } else {
      setSearchParams({ categoria: categoriaId });
    }
  };

  return (
    <div className="produtos-page">
      <div className="produtos-hero">
        <h1>Nossos Produtos</h1>
        <p>Explore nossa seleção de delícias artesanais</p>
      </div>

      <div className="container">
        {/* Filtros de Categoria */}
        <div className="categorias-filtro">
          <Button
            variant={categoriaAtiva === 'todos' ? 'default' : 'outline'}
            onClick={() => handleCategoriaClick('todos')}
            className="filtro-btn"
          >
            Todos
          </Button>
          {categorias.map((categoria) => (
            <Button
              key={categoria.id}
              variant={categoriaAtiva === categoria.id ? 'default' : 'outline'}
              onClick={() => handleCategoriaClick(categoria.id)}
              className="filtro-btn"
            >
              {categoria.nome}
            </Button>
          ))}
        </div>

        {/* Grid de Produtos */}
        {loading ? (
          <div className="produtos-loading">Carregando produtos...</div>
        ) : (
          <>
            <div className="produtos-grid">
              {produtos.map((produto) => (
                <Card key={produto.id} className="produto-card">
                  <div className="produto-imagem-container">
                    <img
                      src={produto.imagem}
                      alt={produto.nome}
                      className="produto-imagem"
                    />
                  </div>
                  <CardContent className="produto-conteudo">
                    <h3 className="produto-nome">{produto.nome}</h3>
                    <p className="produto-descricao">{produto.descricao}</p>
                    <div className="produto-footer">
                      <span className="produto-preco">{produto.preco}</span>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>

            {produtos.length === 0 && (
              <div className="produtos-vazio">
                <p>Nenhum produto encontrado nesta categoria.</p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Produtos;
